import React, {useEffect, useContext} from 'react';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';
import {ToolsMenu} from '../Tools/ToolsMenu'
import PollsTest from './PollsTest';
import {Switch, Route} from 'react-router-dom'
import {AppContext} from '../../context/app/appContext';

/*const PollsRender = () => {
  return (<div> Hello from the out side</div>);
}*/
export const ToolsPage = (props) => {
  const appContext = useContext(AppContext);
  useEffect(() => {
    if (!appContext.teams.length) {
        (async function loadTeams() {
            await appContext.loadTeams();
        })();
    }
    // eslint-disable-next-line
}, []);

useEffect(() => {
    if (!appContext.employees.length) {
        (async function loadEmployees() {
            await appContext.setEmployees();
        })();
    }
    // eslint-disable-next-line
}, []);
  return (
      // <div id="app">
      //   <TopBar/>
      //   <div id="app-body">
      //     <div className="ui grid">
      //       <div className="three wide column">
      //         <Sidebar/>
      //       </div>
      //       <div id="content" className="thirteen wide column">

      //         <div id="tools-page" className="dashboard-page">
      //           <header>
      //             <h3>Tools</h3>
      //           </header>
      //           <div className="tools-navbar">
      //             <div className="navbar-content" >Polls</div>
      //           </div>
      //             <PollsTest/>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
          <div id="app">
            <div id="content" style={{display: 'flex', height: '100vh'}}>
                <span style={{width: '10vw', height: '100vh'}}>
                    <Sidebar />
                </span>
                <span style={{width: '90vw', height: '100vh'}}>
                    <div style={{width: '100%', height: '10vh'}}>
                        <TopBar />
                    </div>
                    <div style={{width: '90vw', height: '91.5vh', overflowY: 'scroll', overflowX: 'visible'}}>
                      <ToolsMenu />
                      <div id="tools-page">
                      <div className="tools-navbar">
                        {/* <div className="navbar-content" > */}
                          <Switch>
                            <Route exact path="/tools"><PollsTest/></Route>
                          </Switch>
                        {/* </div> */}
                      </div>
                    </div>
                    </div>
                </span>
            </div>
        </div>
  );
};
